export enum PromotionPurchaseRuleType {
    MinimumQuantity = "MinimumQuantity",
    MinimumDollar = "MinimumDollar",
    Multiple = "Multiple",
}
